import React from 'react';
import UnsupportedBrowserBanner from 'components/UnsupportedBrowserBanner';
import { useUrgencyBanner } from 'components/UrgencyBanner/useUrgencyBanner';
import UrgencyBannerSelector from 'components/UrgencyBanner/Banner/UrgencyBannerSelector';

export interface TopBannerProps {
  isSupportedBrowser?: boolean;
}

export const TopBanner = ({ isSupportedBrowser = true }: TopBannerProps) => {
  const showUrgencyBanner = !!useUrgencyBanner()[0];

  if (showUrgencyBanner) return <UrgencyBannerSelector />;

  if (!isSupportedBrowser) {
    return <UnsupportedBrowserBanner />;
  }

  return null;
};
